// Types
import { GetStreams_streamsV2_entities } from 'api/streams/types/GetStreams';
import { StreamStatus } from 'api/graphql-global-types';
// Hooks
import { useGetCurrUser } from 'hooks';
import { useStreamNavigation } from 'hooks/useStreamNavigation';
import { useTicketingLaunched } from 'hooks/useTicketingLaunched';
// Ui3
import ContentCard from 'ui3/Card/ContentCard';
// Constants
import { ATHLETES } from 'constants/routes';
// Helpers
import { getStreamStatus } from 'helpers/streams';
import { formatCurrencyString } from 'helpers/formatCurrencyString';
// Styles
import styles from './StreamsList.module.scss';

type StreamsListProps = {
  streams: GetStreams_streamsV2_entities[];
};

const StreamsList = ({ streams }: StreamsListProps) => {
  const { data: currentUser } = useGetCurrUser();
  const getStreamNavigationProps = useStreamNavigation(
    currentUser?.me.id || null
  );
  const ticketingLaunched = useTicketingLaunched();

  if (!streams?.length) {
    return null;
  }

  return (
    <ul className={styles.root}>
      {streams.map((stream: GetStreams_streamsV2_entities) => {
        const { linkUrl } = getStreamNavigationProps(stream);
        // A PPV recording freed by the auto-free cron keeps its original
        // `price` on purpose, so `isFree` — not a zero price — is what decides
        // whether the card advertises a price or a playable recording.
        const isFreeToWatch = stream?.isFree || stream?.price === 0;
        const isPlayable =
          stream?.streamStatus === StreamStatus.Ended &&
          (isFreeToWatch || stream?.isPurchased);

        return (
          <li key={stream.id}>
            <ContentCard
              type={stream.type}
              status={getStreamStatus(
                stream.repeatsEveryEnum,
                stream.isHidden,
                stream.streamStatus
              )}
              descriptionClassName={styles.infoWrapper}
              imageUrl={stream?.imageURL || ''}
              linkUrl={linkUrl}
              dateTime={stream?.scheduleDate || ''}
              tzCode={stream?.timeZone?.tzCode || null}
              title={stream?.name || ''}
              price={
                isFreeToWatch ? 'free' : formatCurrencyString(stream?.price)
              }
              user={stream.store?.storeDetails?.storeName || ''}
              userUrl={stream.store?.slug ? `/${stream.store?.slug}` : ATHLETES}
              isPlay={isPlayable}
              isTicketed={
                ticketingLaunched && Boolean(stream.ticketEvent?.ticketsEnabled)
              }
            />
          </li>
        );
      })}
    </ul>
  );
};

export default StreamsList;
